import { LayerGroup, PlusCircle, Trash } from '@styled-icons/fa-solid';
import { useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import UploadIcon from '../../../../images/Upload.svg';
import {
  deleteChed,
  getChed,
  getListLoad,
  postAdditionalEPOFile,
  postC21Submit,
  postEADSubmit,
  postListLoad,
  postSDISubmit,
  postSFDSubmit,
  updateTransactionLoadUploadedDocumentStatus,
} from '../../../apiCalls';
import ArrivalConfirmation from '../../../ArrivalConfirmation';
import DataTable from '../../../DataTable';
import { useDataTableHandle } from '../../../DataTable/DataTable';
import { DeclarationsButton } from '../../../DeclarationsButton';
import { GoogleAnalyticsContext } from '../../../GoogleAnalytics';
import LoadStatusIcon from '../../../LoadStatusIcon/LoadStatusIcon';
import { ShowIf, useSecurity } from '../../../Security/security';
import StatusRefreshButton from '../../../StatusRefreshButton';
import { StoreContext } from '../../../Store';
import { EpoJobDetailContext } from '../EpoJobDetails';
import './epolistloads.css';
import ResubmissionModal from './ResubmissionModal';
import {
  normaliseBoolean,
  systemReferenceHasAnyStatusErrors,
  validateSystemReferenceFromStatus,
} from '../../../../utils/loads';
import PermissionDeniedModal from '../../../Newload/PermissionDeniedModal/PermissionDeniedModal';
import { parseClearanceDate } from '../../../../utils/stringUtils';
import { ImportType } from '../../../../utils/enums';
import AddSubtaskModal from './AddSubtaskModal';
import { addSubtask } from '../../../apiCalls';
import LoadCompletedModal from '../../../LoadCompletedModal/LoadCompletedModal';
import ToastNotification from '../../../Toast/ToastNotification';

const SUBTASK_ADD_SUCCESS_MSG = 'Subtask added successfully!';
const SUBTASK_INVALID_ROUTE_MSG = 'Invalid route for Subtask';

export default function EpoJobStatus() {
  const {
    jobDetails,
    showArrivalModal,
    setShowArrivalModal,
    setModalItem,
    modalItem,
    tab,
    hasDutyOrVatOrExcise,
    loadingDutyData,
    loadIsReadOnly,
  } = useContext(EpoJobDetailContext);
  const ga = useContext(GoogleAnalyticsContext);
  const { id } = useParams();
  const store = useContext(StoreContext);
  const [requestFailed, setRequestFailed] = useState(false);
  const dataHandle = useDataTableHandle();
  const [error, setError] = useState();
  const { validateRole } = useSecurity();
  const [showResubmissionModal, setShowResubmissionModal] = useState(false);
  const [systemReferenceHasErrors, setSystemReferenceHasErrors] = useState();
  const [showPermissionDeniedModal, setShowPermissionDeniedModal] = useState(false);
  const [showAddSubtaskModal, setShowAddSubtaskModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({ type: 'success', message: '' });

  const showStatusToast = (message, variant = 'success') => {
    setToastConfig({ type: variant === 'danger' ? 'error' : 'success', message });
    setShowToast(true);
  };
  const [showLoadCompletedModal, setShowLoadCompletedModal] = useState(false);
  const [sfdRow, setSfdRow] = useState(null);

  const isDutyUser = validateRole({ isDutyUser: true });
  const isTraderUser = validateRole({ department: 'TRADER' });
  const isLoadCompletedForTrader = isTraderUser && jobDetails?.EPOStatus === 'Completed';

  // Check if trader has uploaded an IPAFFS
  const hasTraderUploadedIpaffs = store.gridItems[0]?.some((item) => {
    const formType = (item['Form type'] || item.formType || '').toString().toUpperCase();
    const additionalInfo = (item['Additional Information'] || item.additionalInformation || '')
      .toString()
      .toUpperCase();
    const isIpaffs = formType.includes('IPAFFS') || additionalInfo.includes('IPAFFS');
    return isIpaffs && (item.customerRequested === true || item.fromEpoSubmission === true);
  });
  useEffect(() => {
    async function fetchData() {
      if (tab === 'status') {
        try {
          await refreshGrid();
        } catch {
          setRequestFailed(true);
        }
      } else return;
    }
    fetchData();
  }, [tab]);

  useEffect(() => {
    if (!store?.gridItems[0]) return;
    const declarationTypes = ['SDI', 'SFD', 'EAD'];
    declarationTypes.forEach((declarationType) => {
      const info = dataHandle.current.modifiedData.find((row) => row['Additional Information'] === declarationType);
      const value = info && info.formSubmitted ? info.formSubmitted : 0;
      store[`${declarationType.toLowerCase()}Submitted`][1](value);
    });
  }, [store?.gridItems, dataHandle?.current?.modifiedData]);

  const handleDocSubmit = async () => {
    const sfdRequest = {
      id: id,
    };
    try {
      await postSFDSubmit(sfdRequest);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending SFD');
    }
  };

  const handleC21Submit = async () => {
    const c21Request = {
      id: id,
    };
    try {
      await postC21Submit(c21Request);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending C21');
    }
  };

  const handleEADSubmit = async () => {
    const EADRequest = {
      id: id,
    };
    try {
      await postEADSubmit(EADRequest);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending EAD');
    }
  };

  const handleSdiClick = (item) => {
    if (isDutyUser || !hasDutyOrVatOrExcise) {
      handleOpenModal(item);
    } else {
      setShowPermissionDeniedModal(true);
    }
  };

  const handleOpenModal = (item) => {
    setModalItem(item);
    setShowArrivalModal(true);
  };

  const createListLoadPayload = () => {
    const updatedCells = [];
    let i = 0;

    for (const row of dataHandle.current.modifiedData) {
      const system = row['System'];
      const refNo = row['System Ref No.'].toUpperCase();

      updatedCells.push({
        colname: 'System',
        rowid: row.id,
        staterow: i++,
        value: system,
      });

      updatedCells.push({
        colname: 'SystemRefNo',
        rowid: row.id,
        staterow: i++,
        value: refNo,
      });
    }
    const invLinked = dataHandle.current.modifiedData.find((row) => {
      return row['Form type'] === 'Inventory linked release';
    });
    if (invLinked) {
      updatedCells.push({
        colname: 'PortArrived',
        rowid: invLinked.id,
        staterow: i++,
        value: (invLinked.PortArrived?.id ? invLinked.PortArrived.id : invLinked.PortArrived) ?? null,
      });
    }

    postListLoadPayload(updatedCells);
  };

  const postListLoadPayload = async (payload) => {
    try {
      const data = await postListLoad(payload, 'status');
      if (data[0].completed === 'Updated') {
        store.saved[1](data);
        await refreshGrid();
      }
    } catch (err) {
      console.error(err);
      alert('Error saving to DB');
    }
  };

  const handleSubmit = () => {
    setError();

    const sdi = dataHandle.current.modifiedData.find((row) => {
      return row['Additional Information'] === 'SDI';
    });

    if (sdi) {
      if (sdi.Status === 'Submitted' && !!sdi['System Ref No.']) {
        setError('Please request SDI (see button) before submitting a system reference number');
        return;
      }
    }

    const sfd = dataHandle.current.modifiedData.find((row) => {
      return row['Additional Information'] === 'SFD';
    });

    if (sfd) {
      if (sfd.Status === 'Submitted' && !!sfd['System Ref No.']) {
        setError('Please request an SFD (see button) before submitting MUCR/UCN reference number');
        return;
      }
    }

    createListLoadPayload();
  };

  const handleAddSubtask = async (subtaskData) => {
    try {
      // Must use subTasktId (the ID from API), not the type string
      if (!subtaskData.subTasktId) {
        alert('Error: Subtask ID is missing. Please try again.');
        return;
      }

      const subTaskId = subtaskData.subTasktId;

      // Use jobDetails.newLoadId for EPO
      const newLoadId = jobDetails?.newLoadId || id;
      const data = await addSubtask(newLoadId, subTaskId, true);
      if (data[0]?.status === 'Failed') {
        showStatusToast(SUBTASK_INVALID_ROUTE_MSG, 'danger');
        return;
      }
      showStatusToast(SUBTASK_ADD_SUCCESS_MSG);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      showStatusToast('Error creating subtask.', 'danger');
    }
  };

  const removeRow = async (docId) => {
    if (!docId) {
      showStatusToast('Cannot delete: Document ID is missing', 'danger');
      return;
    }
    try {
      const data = await deleteChed(docId);
      if (data) {
        store.gridItems[1](data);
      }
      await refreshGrid();
      showStatusToast('Subtask deleted successfully!');
    } catch (err) {
      console.error('Error deleting subtask:', err);
      showStatusToast('Error deleting subtask. Please try again.', 'danger');
    }
  };

  const refreshGrid = async () => {
    try {
      const data = await getListLoad('status', id);
      store.gridItems[1](data);
      const sfd = data.find((item) => item['Additional Information'] === ImportType.SFD);
      setSfdRow(sfd);

      if (sfd?.CustomsAcceptanceDate) {
        const { date, time } = parseClearanceDate(sfd.CustomsAcceptanceDate);
        store.portArrivalDate[1](date);
        store.portArrivalTime[1](time);
      } else {
        store.portArrivalDate[1](null);
        store.portArrivalTime[1](null);
      }
    } catch {
      setRequestFailed(true);
    }
  };

  const handleModalSubmit = async () => {
    const sdiRequest = {
      id: id,
      date: store.portArrivalDate[0],
      time: store.portArrivalTime[0],
    };
    try {
      await postSDISubmit(sdiRequest);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error sending SDI');
    }
  };

  const processFile = async (file, transactionID, transactionType) => {
    try {
      const formData = new FormData();
      formData.append('documents', file);
      formData.append('documentNames', transactionType);
      formData.append('id', id);

      const response = await postAdditionalEPOFile(formData);

      if (response.success) {
        const uploadedDocumentData = new FormData();
        uploadedDocumentData.append('id', transactionID);
        const response = await updateTransactionLoadUploadedDocumentStatus(transactionID);

        if (response[0].completed === 'Updated') {
          createListLoadPayload();
        }
      } else {
        console.error('response.error: ', response);
        setError(`The following error occurred while processing the file: ${response.error}`);
      }
    } catch (err) {
      console.error(err);
      setError('We could not process your file, please review the file and try again.');
    }
  };

  const uploadDocument = (e, transactionID, transactionType) => {
    const acceptedFiles = e.accept;
    const fileExtension = e.files[0]?.name?.slice(-4)?.toLowerCase();
    const isUploadedDocumentValid = acceptedFiles.includes(fileExtension);
    if (isUploadedDocumentValid) {
      processFile(e.files[0], transactionID, transactionType);
    }
  };

  const UploadDocumentStatus = () => {
    return (
      <span className="icon-md rounded-circle">
        <svg xmlns="http://www.w3.org/2000/svg" className="icon-sm" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  };

  const getRefreshMessage = (item) => {
    if (item?.['System Ref No.']) {
      return 'You are unable to submit this declaration as a response has been received from Descartes.';
    } else if (!item?.resubmissionAvailable && item?.formSubmitted) {
      return 'You can only resubmit this declaration two times';
    } else return '';
  };

  const setGATagForResubmission = (declarationType) => {
    if (ga.gaInitialized && declarationType) {
      window?.gtag?.('event', `${declarationType} resubmitted`, {
        event_category: 'Resubmit Declaration',
      });
    }
  };

  const submitDeclaration = async () => {
    try {
      const requiresDate = showResubmissionModal == 'SDI';

      const payload = {
        id,
        resubmission: true,
        ...(requiresDate && {
          date: new Date().toISOString().split('T')[0],
          time: store.portArrivalTime[0] || '12:00',
        }),
      };

      switch (showResubmissionModal) {
        case 'SDI':
          await postSDISubmit(payload);
          break;
        case 'SFD':
          await postSFDSubmit(payload);
          break;
        case 'C21':
          await postC21Submit(payload);
          break;
        case 'EAD':
          await postEADSubmit(payload);
          break;
        default:
          alert('No declaration type selected for resubmission: ' + showResubmissionModal);
          return;
      }
      setGATagForResubmission(showResubmissionModal);
      await refreshGrid();
    } catch (err) {
      console.error(err);
      alert('Error resubmitting ' + showResubmissionModal);
    }
  };

  return (
    <div className="floating-box-newload loaditems">
      <ToastNotification
        show={showToast}
        onClose={() => setShowToast(false)}
        type={toastConfig.type}
        message={toastConfig.message}
      />
      <PermissionDeniedModal show={showPermissionDeniedModal} onHide={() => setShowPermissionDeniedModal(false)} />
      <LoadCompletedModal show={showLoadCompletedModal} onHide={() => setShowLoadCompletedModal(false)} />
      <ResubmissionModal
        show={showResubmissionModal}
        onHide={() => setShowResubmissionModal(false)}
        submitDeclaration={submitDeclaration}
        referenceNo={jobDetails?.TransferID}
      />
      <DataTable
        data={store.gridItems[0]}
        className="table-striped table-bordered"
        editable
        handle={dataHandle}
        onMutate={(localData) => {
          const allValid = systemReferenceHasAnyStatusErrors(localData);
          setSystemReferenceHasErrors(allValid);
        }}
      >
        <DataTable.Headers className="bg-white" style={{ fontSize: '13px' }} />
        <DataTable.Column colKey="Form type" header="Transaction" />
        <DataTable.Column colKey="Country/Port" header="Location" />
        <DataTable.Column colKey="Additional Information" header="Additional Information" maxWidth="26ch" />
        <DataTable.Column
          colKey="System Ref No."
          header="System Reference"
          className="p-2 edit-cell system-reference uppercase-text"
          maxWidth="17ch"
          editable={(item) => {
            if (
              (validateRole({ department: 'OPS' }) || validateRole({ department: 'QA' })) &&
              item['Additional Information'] === 'SDI' &&
              item.Status === 'In progress' &&
              !loadIsReadOnly
            ) {
              return item.SFD;
            } else if (
              (validateRole({ department: 'OPS' }) || validateRole({ department: 'QA' })) &&
              item['Additional Information'] === 'SDI' &&
              item.Status === 'Completed' &&
              !loadIsReadOnly
            ) {
              return true;
            } else {
              return !item.locked && !loadIsReadOnly;
            }
          }}
          validator={validateSystemReferenceFromStatus}
        />
        <DataTable.Column colKey="Status" header="Status">
          {(item) => <LoadStatusIcon status={item} />}
        </DataTable.Column>
        <DataTable.Column header="Submit" style={{ whiteSpace: 'nowrap', width: '1px' }}>
          {(item) => {
            return (
              <DeclarationsButton
                C21={item.C21}
                SFD={item.SFD}
                SDI={item.SDI}
                EAD={item.EAD}
                CHED={item.CHED}
                ENS={item.ENS}
                TAD={item.TAD}
                InventoryLinked={item.InventoryLinked}
                Status={item.Status}
                formSubmitted={item.formSubmitted}
                handleOpenModal={() => handleSdiClick(item)}
                handleDocSubmit={() => handleDocSubmit(item)}
                handleEADSubmit={() => handleEADSubmit(item)}
                handleC21Submit={() => handleC21Submit(item)}
                loading={loadingDutyData}
                editable={!loadIsReadOnly}
              />
            );
          }}
        </DataTable.Column>
        <DataTable.Column header="Docs" style={{ whiteSpace: 'nowrap', width: '4.5rem' }}>
          {(item) => {
            const elmID = `row-${item.id}-uploadedDocument`;
            return (
              <>
                <input type="hidden" name={elmID} value={!!item.uploadedDocument} />
                <span className="docs-upload-status">
                  <span className="uploadBtn">
                    <label
                      name="name"
                      onClick={(e) => {
                        if (isLoadCompletedForTrader) {
                          e.preventDefault();
                          e.stopPropagation();
                          setShowLoadCompletedModal(true);
                        }
                      }}
                    >
                      <img
                        src={UploadIcon}
                        alt="Click to upload document"
                        title="Click to upload document"
                        width="22"
                        height="22"
                      />
                      <input
                        type="file"
                        name="fileuploader"
                        onChange={(e) => uploadDocument(e.target, item?.id, item['Additional Information'])}
                        onClick={(e) => {
                          if (isLoadCompletedForTrader) {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowLoadCompletedModal(true);
                          } else {
                            e.target.value = null;
                            setError('');
                          }
                        }}
                        accept=".pdf,.png,.jpeg,.xls,.xlsx"
                        multiple
                      />
                    </label>
                  </span>
                  {item.uploadedDocument && <UploadDocumentStatus />}
                </span>
              </>
            );
          }}
        </DataTable.Column>
        <DataTable.Column header="Actions" style={{ whiteSpace: 'nowrap', width: '1.5rem' }}>
          {(item) => (
            <>
              <StatusRefreshButton
                item={item}
                setShowResubmissionModal={setShowResubmissionModal}
                disabled={!item?.resubmissionAvailable || loadIsReadOnly}
                message={getRefreshMessage(item)}
              />

              <ShowIf or={[{ department: 'OPS' }, { department: 'QA' }]}>
                <Link
                  to={`/DeclarationsHistory/${jobDetails.id}/${item.id}`}
                  state={{ prevPath: window.location.pathname, isEpo: true }}
                >
                  <LayerGroup className="text-secondary" width="1rem" height="1rem" />
                </Link>
              </ShowIf>
            </>
          )}
        </DataTable.Column>
        <DataTable.Column
          header="Delete"
          style={{ whiteSpace: 'nowrap', width: '2rem', textAlign: 'center' }}
          className="p-0"
        >
          {(item) => {
            const canDelete = normaliseBoolean(item.isSubTask);

            return (
              <button
                className="subtask-delete-button"
                onClick={() => {
                  if (item.id && canDelete) {
                    removeRow(item.id);
                  } else if (!item.id) {
                    showStatusToast('Cannot delete: Item ID is missing', 'danger');
                  }
                }}
                disabled={!canDelete || !item.id}
                title={
                  canDelete && item.id
                    ? 'Delete subtask'
                    : !item.id
                      ? 'Cannot delete: Missing item ID'
                      : 'Cannot delete this subtask'
                }
              >
                <Trash width="1rem" height="1rem" />
              </button>
            );
          }}
        </DataTable.Column>
      </DataTable>

      <AddSubtaskModal
        show={showAddSubtaskModal}
        onHide={() => setShowAddSubtaskModal(false)}
        onSubmit={handleAddSubtask}
        isEpo={true}
        hasTraderUploadedIpaffs={hasTraderUploadedIpaffs}
      />

      <button type="button" className="invoice-add-btn green-text" onClick={() => setShowAddSubtaskModal(true)}>
        <PlusCircle width="1.4rem" height="1.4rem" />
        <span className="text-decoration-underline bold" style={{ fontSize: '1rem' }}>
          Add a Subtask
        </span>
      </button>

      <div className="d-flex flex-row py-3 px-3 mt-4 gap-3 border-top">
        <div className="flex-grow-1" />
        <div className="">
          {error && (
            <div className="alert-danger px-3 py-2 w-100 " style={{ borderRadius: '10px', textAlign: 'center' }}>
              {error}
            </div>
          )}
        </div>
        <div className="flex-grow-1" />
        <button className="stepper-button red" onClick={handleSubmit} disabled={systemReferenceHasErrors}>
          Update
        </button>
      </div>
      <ArrivalConfirmation
        show={showArrivalModal}
        onHide={() => {
          setShowArrivalModal(false);
          setModalItem(null);
        }}
        onConfirm={handleModalSubmit}
        item={modalItem}
        hasSfd={!!sfdRow}
        sfdArrived={!!sfdRow?.CustomsAcceptanceDate}
      />
    </div>
  );
}
